import script from "./SideFloat.vue?vue&type=script&setup=true&lang=js"
export * from "./SideFloat.vue?vue&type=script&setup=true&lang=js"

import "./SideFloat.vue?vue&type=style&index=0&id=51319a64&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51319a64"]])

export default __exports__